import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
import UserStorageDisplay from './components/UserStorageDisplay.vue'

declareVconsoleComponent('userStorageDisplay', UserStorageDisplay)
